import { api } from "./client";
import type { BulkCreateResponse, ShiftTemplate, TemplatePreview, TemplateRunBody } from "./types";

export interface TemplateInput {
  name: string; venue_id: string; role_id: string; start_time_local: string | null; end_time_local: string | null;
  ends_next_day: boolean; instructions: string | null; default_employee_ids: string[];
}
const T = "/admin/shift-templates";
export const templateApi = {
  list: (q?: string) => api.get<ShiftTemplate[]>(`${T}${q ? `?q=${encodeURIComponent(q)}` : ""}`),
  create: (b: TemplateInput) => api.post<ShiftTemplate>(T, b),
  update: (id: string, b: TemplateInput) => api.put<ShiftTemplate>(`${T}/${id}`, b),
  duplicate: (id: string) => api.post<ShiftTemplate>(`${T}/${id}/duplicate`),
  remove: (id: string) => api.del<{ outcome: "ARCHIVED" | "DELETED" }>(`${T}/${id}`),
  preview: (id: string, b: TemplateRunBody) => api.post<TemplatePreview>(`${T}/${id}/preview`, b),
  createShifts: (id: string, b: TemplateRunBody) => api.post<BulkCreateResponse & { replayed: boolean }>(`${T}/${id}/create-shifts`, b),
  series: (id: string) => api.get<{ live: number; cancellable: number; dates: string[] }>(`/admin/shift-series/${id}`),
  cancelSeries: (id: string, reason: string) => api.post<{ cancelled: number }>(`/admin/shift-series/${id}/cancel`, { reason }),
};
